import { register } from '../../../JavaScript/Utils'

const WeglotSwitchCollector = el => {
  const Weglot = window.Weglot
  const switcherDomCollection = document.querySelectorAll('.comp-weglot-language-switch')

  const switcherObjects = [...switcherDomCollection].map(switcher => {
    return {
      style: {
        full_name: false
      },
      location: {
        target: `.${switcher.dataset.selector}`,
        sibling: null
      }
    }
  })

  const init = () => {
    Weglot.on('switchersReady', () => {
      window.setTimeout(() => {
        switcherDomCollection.forEach(switcher => switcher.classList.remove('loading'))
      }, 500)
    })

    Weglot.initialize({
      api_key: 'wg_6e7ad1a63d3f3ce58881c55a5a0461859',
      switchers: switcherObjects
    })
  }

  init()
}

register('WeglotSwitchCollector', WeglotSwitchCollector)
